import RatingStars from '@components/CustomerStory/RatingStars/RatingStars'
import { convertToSlug } from '@utils/IdGenerator'
import { expertQuoteType } from '@interfaces/ExpertQuote'
import { expertQuoteUITypes } from '@enums/ExpertQuote'
import { yellowQuote, orangeQuote } from './const'
import styles from './expertQuote.module.scss'

const ExpertQuote = props => {
  const data: expertQuoteType = props?.data?.data?.attributes
  if (!data?.type) return null
  switch (data.type) {
    case expertQuoteUITypes.JustQuotes:
      return (
        <div className={styles.container} id={data.headerTabName && convertToSlug(data.headerTabName)}>
          <div className={styles.justQuoteContainer}>
            <div className={styles.quote}>
              <img src={yellowQuote} className={styles.quoteImg} />
              <p className={styles.quoteText}>{data.expertQuote}</p>
            </div>
            <div className={styles.expert}>
              {data.expertImg?.data && <img src={data.expertImg.data.attributes.url} />}
              <div className={styles.expertContent}>
                <p className={styles.expertName}>{data.expertName}</p>
                <p className={styles.expertTitle}>{data.expertTitle}</p>
              </div>
            </div>
          </div>
        </div>
      )
    case expertQuoteUITypes.QuoteWithBanner:
      return (
        <div className={styles.container} id={data.headerTabName && convertToSlug(data.headerTabName)}>
          <div className={styles.quoteWithBannerContainer}>
            <picture className={styles.banner}>
              <source srcSet={data.bannerMobileImg.data?.attributes?.url} media="screen and (max-width: 756px)" />
              <img src={data.bannerDesktopImg.data?.attributes?.url} />
            </picture>
            <div className={styles.quote}>
              <img src={orangeQuote} className={styles.quoteImg} />
              <p className={styles.quoteText}>{data.expertQuote}</p>
              <p className={styles.star}>
                <RatingStars rating={data.rating} total={5} />
              </p>
              <div className={styles.expertContent}>
                <p className={styles.expertName}>{data.expertName}</p>
                <p className={styles.expertTitle}>{data.expertTitle}</p>
              </div>
            </div>
          </div>
        </div>
      )
    default:
      return null
  }
}

export default ExpertQuote
